import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { learnMoreBtnType } from "components/LearnMoreBtn";
import {
  CloseMenuArea,
  CloseModalButton,
  CloseModalIcon,
  ModalSection,
  ModalSectionBreak,
  ModalSectionButton,
  ModalSectionDescription,
  ModalSectionIconContainer,
  ModalSectionTitle,
  SigninModal,
} from "../styles";

const SignInModal = ({ closeModal, isOpen }) => {
  return (
    <>
      <CloseMenuArea isOpen={isOpen} onClick={() => closeModal()} />
      <SigninModal isOpen={isOpen}>
        <CloseModalButton onClick={() => closeModal()}>
          <CloseModalIcon type={"Close"} />
        </CloseModalButton>
        <ModalSection>
          <ModalSectionIconContainer>
            <StaticImage src="../../../images/Home.png" alt="" />
          </ModalSectionIconContainer>
          <ModalSectionTitle>HOMEOWNERS</ModalSectionTitle>
          <ModalSectionDescription>
            Manage your home, view camera recordings and edit user permissions.
          </ModalSectionDescription>
          <ModalSectionButton
            btnUrl="https://home.savant.com"
            btnType={learnMoreBtnType.fullOrangeBtn}
            openInNewTab={true}
          >
            SIGN IN
          </ModalSectionButton>
        </ModalSection>
        <ModalSectionBreak />
        <ModalSection>
          <ModalSectionIconContainer>
            <StaticImage src="../../../images/Support.png" alt="" />
          </ModalSectionIconContainer>
          <ModalSectionTitle>DEALERS</ModalSectionTitle>
          <ModalSectionDescription>
            Visit the Savant Community, manage jobs, purchase from the store.
          </ModalSectionDescription>
          <ModalSectionButton
            btnUrl="https://community.savant.com/Customers"
            btnType={learnMoreBtnType.fullOrangeBtn}
            openInNewTab={true}
          >
            SIGN IN
          </ModalSectionButton>
        </ModalSection>
      </SigninModal>
    </>
  );
};

export default SignInModal;
